import { cn } from '@eliadmin/core/src/utils/style-utils';

interface HeadingProps {
  subtitle: string;
  title: string;
  titleAs?: 'h1' | 'h2';
  className?: {
    container?: string;
    subtitle?: string;
    title?: string;
  };
}

export function Heading({ subtitle, title, titleAs = 'h2', className }: HeadingProps) {
  const TitleTag = titleAs;
  return (
    <div className={cn('flex flex-col gap-4', className?.container)}>
      <p
        data-ea-visual-tag="h3"
        className={cn(
          'text-lg font-extrabold text-primary sm:text-xl lg:text-2xl',
          className?.subtitle,
        )}
      >
        {subtitle}
      </p>
      <TitleTag
        className={cn(
          'text-5xl font-medium tracking-tight text-black md:text-5xl xl:text-6xl',
          'font-heading',
          className?.title,
        )}
      >
        {title}
      </TitleTag>
    </div>
  );
}
